define('modules/form/form_section_model',[
  'backbone',
  'jquery',
  '_'


  ], function(Backbone, $, _) {
    'use strict';
    var Section = Backbone.Model.extend({
      defaults: function() {
        return {
          'slug': '',
          'title': 'Section title',
          'short_desc': '',
          'error': false,
          'error_message': '',
          'toggle_all': false,
          'removable': false,
          'html_ad_section_id': _.uniqueId('temp_'),
          'html_template_section_name': '',
          'max_copies': 1,
          'show_add_button': false
        };
      }
    });
    return Section;
  });

